<template>
  <div class="container-root">
    <Breadcrumb :items.sync="breadcrumb"></Breadcrumb>
    <div class="loader" v-if="isLoading"></div>
    <div v-if="breadcrumb.length === 1 && !isLoading">
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold">MY PAYSLIPS</h2>
      </div>
      <div class="space">
        For any query about your payslip, please contact HR in person or via
        email: hrd@regentsschoolbali.com
      </div>
      <div class="space">
        <Table
          :title="'Payslips'"
          :model="list.table"
          :isLoading="list.isLoading"
          :selectedId.sync="selectedId"
        >
          <div class="control-group">
            <div class="control-title">YEAR</div>
            <select class="control" v-model="year.selected">
              <option v-for="(option, optionIdx) in year.data" :key="optionIdx">
                {{ option }}
              </option>
            </select>
          </div>
        </Table>
      </div>
    </div>
    <PayslipDetails
      v-if="breadcrumb.length === 2"
      :model="selectedModel"
      :month="selectedMonth"
      :profile="profile"
      :year="year.selected"
    ></PayslipDetails>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { utils, http } from '../digilib_web/core/digitify';
import { constants } from '../js/regents';
import Table from '../digilib_web/vue/table';
import Breadcrumb from '../digilib_web/vue/breadcrumb';
import PayslipDetails from './staff_payslips_details';

export default {
  props: {
    profile: Object
  },
  watch: {
    breadcrumb: {
      handler(n) {
        // reset data when home
        if (n.length === 1) {
          this.reloadTable();
        }
      }
    },
    selectedId: {
      handler(id) {
        if (id > -1) {
          let selected = this.list.payslips.find(x => x.id === id);
          let m = dayjs(selected.payment_date);
          this.selectedMonth = parseInt(m.format('M'), 10);
          let endpoint = `employees/payslips/list/${this.selectedMonth}/${
            this.year.selected
          }/${selected.id}`;
          // get the payslip details data
          this.isLoading = true;
          http.get(endpoint).then(json => {
            // set the model
            this.selectedModel = json.data;
            // set the breadcrumb
            this.breadcrumb.push({
              text: this.selectedMonth + '-' + this.year.selected + ' Payslip'
            });
            this.isLoading = false;
          });
        }
      }
    },
    'year.selected': {
      handler(n) {
        this.reloadTable();
      }
    }
  },
  methods: {
    reloadTable() {
      this.selectedId = -1;
      this.list.isLoading = true;
      // get the payslips of the currently logged in employee for each year
      let selectedYear = this.year.selected;
      let idEmp = this.profile.id;
      let endpoint = `employees/payslips?where=id_employee,=,${idEmp}|is_published,=,true|payment_date,>=,${selectedYear}-01-01|payment_date,<,${selectedYear +
        1}-01-01`;
      http.get(endpoint).then(json => {
        this.list.isLoading = false;
        this.list.payslips = json.data;
        // generate the table data
        this.list.table = utils.toTable(this.list.payslips, {
          payment_date: { title: 'date', type: 'date' },
          salary: { title: 'salary' }
        });
      });
    }
  },
  mounted() {
    // set selected month and year
    let m = dayjs();
    this.year.selected = parseInt(m.format('YYYY'), 10);
    // load table data
    this.reloadTable();
  },
  data() {
    return {
      notif: null,
      selectedId: -1,
      selectedModel: null,
      selectedMonth: -1,
      selectedYear: -1,
      isLoading: false,
      year: {
        data: constants.YEARS,
        selected: null
      },
      list: {
        isLoading: false,
        table: {},
        payslips: []
      },
      breadcrumb: [{ icon: 'fa fa-home', text: 'my payslips' }]
    };
  },
  components: {
    Table,
    Breadcrumb,
    PayslipDetails
  }
};
</script>

<style scoped>
.space {
  margin-top: 20px;
}
.header-group {
  display: flex;
  justify-content: space-between;
}
</style>
